import { makeAutoObservable } from 'mobx'
import { LanguageController } from '@ctrls/index'

const langMap: {
  [key: string]: TLanguage;
} = {
  zh: 'zh-CN',
  'zh-CN': 'zh-CN',
  en: 'en-US',
  'en-US': 'en-US',
  de: 'de-DE',
  'de-DE': 'de-DE',
}
// 系统语言
const navLang: TLanguage = langMap[navigator.language.split('-')?.[0] || 'zh-CN']
// 当前语言
const thisLang: TLanguage = i18n.language || navLang
// 当前项目支持的语言
export const languageEmun = ['zh-CN', 'en-US', 'de-DE']

/** 语言mobx */
class LanguageMobx {
  constructor () {
    makeAutoObservable(this)
  }
  languageList = [navLang]
  init ({ language = [] }) {
    let languageList = [...this.languageList]
    let hasThisLang = false
    language.forEach(({ i18n }) => {
      if ([navLang, i18n].includes(thisLang)) {
        hasThisLang = true
      }
      if (languageEmun.includes(i18n) && i18n !== navLang) {
        languageList.push(i18n)
      }
    })
    if (!hasThisLang && navLang === thisLang) hasThisLang = true
    !hasThisLang && LanguageController.changeLanguage(navLang, false)
    this.languageList = languageList
  }
}

export default new LanguageMobx()
